import { toast } from 'react-toastify';

export const handleReduxResponse = (successMessage) => (resultAction) => {
    
    if (resultAction?.error) {
        toast.error(resultAction.payload);
        return resultAction.payload;
    }
    if (successMessage) {
        toast.success(successMessage);
    }
}